import { useSearchParams } from 'react-router-dom';

export const useQueryParameter = (init?: Record<string, string | string[]>) =>
  useSearchParams(init);
